import { getLocationNameFromId, getPracticeNameFromId } from "../../../../../lib/labels";
import { practicesFunctions } from "../../../../../lib/practices";
import { formatDateLocal, formatCurrency } from "../../../../../lib/script";
import { allNgPatientStatusesOptions, practicePatientStatusesOptions } from "../../../../../lib/systemData";
import CheckboxCell from "../../../../common/interactive/CheckboxCell";
import HoverWrapperInfo from "../../../../wrappers/HoverWrapperInfo";

export default function PracticeDrawerSectionRow({item}) {


    let injectStatus = null

    if (!item?.status_id && item?.nextgen_patient_status) {
        // injectStatus = {
        //     label: item?.nextgen_patient_status,
        //     value: item?.nextgen_patient_status,
        //     manual_selection: true
        // }

        injectStatus = allNgPatientStatusesOptions()?.find(option => option.value == item?.nextgen_patient_status)
    }

    return <tr key={item.id}>
        <td>{getPracticeNameFromId(item.practice_id)}</td>
        {practicesFunctions.getPracticeType(item?.practice_id) == '1' ? <>
            <td><CheckboxCell checked={item.has_hippa} isDisabled={true} setStyle={'centered'}/></td>
            <td><CheckboxCell checked={item.has_lop ?? item.lop} isDisabled={true} setStyle={'centered'}/></td>
        </>
        :
        <>
        <td></td>
        <td></td>
        </>}
        
        <td>{getLocationNameFromId(item.location_id)}</td>
        <td>{item.chart_number}</td>
        <td>
            {formatDateLocal(item.initial_treatment)}
        </td>
        <td>
            {practicePatientStatusesOptions(false, injectStatus)?.find((practiceStatus) => practiceStatus.value == item.status_id)?.label}
        </td>
        <td>
            {item.total_charges !== null ? <>${formatCurrency(item.total_charges)}</> : '-'}
        </td>
        <td>
            {item.balance !== null ? <>${formatCurrency(item.balance)}</> : '-'}
        </td>

        <td>
            {item.mrq_record_upload_via}
        </td>

        <td>
            {item.negotiated_amount !== null ? <>${formatCurrency(item.negotiated_amount)}</> : '-'}
        </td>
        <td>
            <CheckboxCell checked={item.paid} isDisabled={true} setStyle={'centered'}/>
        </td>
        <td>
            {formatDateLocal(item.settlement_date)}
        </td>
    </tr>
}